import { api_banking } from "../services/Api";

export interface PaymentApproval {
  uuid: string;
  amount: number;
  type: string;
  status: string;
  payerName: string;
  payerDocument: string;
  paymentDate: string;
}

export interface PaymentApprovalResponse {
  content: PaymentApproval[];
  pageable: {
    pageNumber: number;
    pageSize: number;
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  last: boolean;
  totalPages: number;
  totalElements: number;
  first: boolean;
  size: number;
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  numberOfElements: number;
  empty: boolean;
}

export interface ApprovalRequest {
  uuid: string;
  isApproved: boolean;
  password: string;
  reproveReason?: string;
}

export function usePaymentApproval() {
  const getPayments = async (idSeller: string | undefined) => {
    if (!idSeller) return;
    return await api_banking.get(`payments/antifraud/${idSeller}`);
  };

  const approvePayment = async (
    idSeller: string | undefined,
    data: ApprovalRequest
  ) => {
    if (!idSeller) return;
    return await api_banking.patch(
      `payments/antifraud/${idSeller}/approval`,
      data
    );
  };

  return {
    getPayments,
    approvePayment,
  };
}
